import React from 'react'
import { Button } from 'antd'
import { ArrowUpOutlined, FilePdfOutlined } from '@ant-design/icons'
import { injectIntl } from 'react-intl'
import _ from 'lodash'
import queryStringSyncEnhancer from 'services/queryStringSyncEnhancer'
import documents, { MAIN_DOCUMENT } from 'assets/documents'
import style from './style.module.scss'

const scrollTop = () => document.getElementsByClassName('ant-modal-wrap')[0].scrollTo(0, 0)

const LegalInfo = ({ updateQueryParam, getQueryParams, intl: { locale, formatMessage } }) => {
  const openDoc = activeDocKey => updateQueryParam({ activeDocKey })
  const activeDocKey = getQueryParams().activeDocKey || MAIN_DOCUMENT;
  const activeDocument = _.get(documents, `${activeDocKey}.${locale}`, null)

  return (
    <div className={style.legalInfo}>
      <nav className={style.docList}>
        {Object.keys(documents).map((docKey) => {
          const document = _.get(documents, `${docKey}.${locale}`, null)

          if (document) {
            return (
              <Button
                key={docKey}
                shape="round"
                type={activeDocKey === docKey ? "primary" : "default"}
                onClick={() => openDoc(docKey)}
              >
                {document.title}
              </Button>
            )
          }

          return null
        })}
      </nav>

      <div className={style.documentContainer}>
        <div className={style.title}>{_.get(activeDocument, 'title', '')}</div>
        <div className={style.body} dangerouslySetInnerHTML={{ __html: _.get(activeDocument, 'body', '') }} />
      </div>

      {activeDocument && activeDocument.file && (
        <a
          className={style.downloadLink}
          target="_blank"
          rel="noopener noreferrer"
          href={activeDocument.file}
        >
          <FilePdfOutlined /> {formatMessage({ id: 'components.legal-info.download-document' })}
        </a>
      )}

      <div className={style.controls}>
        <Button
          icon={<ArrowUpOutlined />}
          shape="circle"
          size="large"
          onClick={scrollTop}
        />
      </div>
    </div>
  )
}

export default queryStringSyncEnhancer(injectIntl(LegalInfo))
